import { NavLink } from 'react-router-dom';

import Chip from '@zenbusiness/zui/Chip';
import { superstyled } from '@zenbusiness/zui/styles';

export const Link = superstyled({
  tag: NavLink,
  name: 'BusinessEntitySelector',
  slot: 'EntityMenuItemLink',
  styles: ({ theme }) => ({
    display: 'flex',
    gap: '0.75rem',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    lineHeight: '1.5',
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem'
    },

    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem'
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: '1.375rem',
      paddingBlock: '1.125rem'
    }
  })
});

export const Pill = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'EntityMenuItemChip',
  tag: Chip,
  propsAdded: {
    color: 'warning'
  },
  styles: {
    padding: '2px 6px',
    borderRadius: 18,
    textTransform: 'uppercase'
  }
});
